/**
 * Season / Eid catalog helpers (website-only; mirrors mobile-app behaviour).
 */

/** @param {unknown} value */
export function normalizeSeasonDate(value) {
    if (value == null || value === false || value === "") {
        return null;
    }
    const match = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})/);
    return match ? match[1] : null;
}

/**
 * @param {{ in_season?: boolean, season?: Array<{ id?: number }>, days?: string[] } | null | undefined} result
 */
export function parseSeasonApiResult(result) {
    const inSeason = !!result?.in_season;
    const seasonRows = Array.isArray(result?.season) ? result.season : [];
    const seasonId = seasonRows[0]?.id ?? null;
    const days = (result?.days || [])
        .map(normalizeSeasonDate)
        .filter(Boolean);
    return { inSeason, seasonId, days };
}

/** Local calendar date as YYYY-MM-DD (matches mobile / browser day for Saudi users). */
export function getTodayDateString(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

/**
 * True on actual Eid sacrifice days from Odoo (`season.days`), not the whole season window.
 * @param {string[]} seasonDays
 * @param {string} [today]
 */
export function isSacrificeDayToday(seasonDays, today = getTodayDateString()) {
    const normalizedToday = normalizeSeasonDate(today);
    if (!normalizedToday) {
        return false;
    }
    return (seasonDays || [])
        .map(normalizeSeasonDate)
        .filter(Boolean)
        .includes(normalizedToday);
}

/**
 * Delivery day from cart lines (seasonal variant `date_start`).
 * @param {Array<{ variants?: Array<{ date_start?: string }> }>} products
 */
export function getSeasonDeliveryDateFromCartProducts(products) {
    for (const product of products || []) {
        for (const variant of product?.variants || []) {
            const day = normalizeSeasonDate(variant?.date_start);
            if (day) {
                return day;
            }
        }
    }
    return null;
}

/** Odoo JSON-RPC date fields used by order create endpoints. */
export function formatOdooDeliveryDay(dateStr) {
    const day = normalizeSeasonDate(dateStr);
    return day ? `${day} 00:00:00` : null;
}

/**
 * Block regular products only on Eid sacrifice days (not during the whole season window).
 * @param {boolean} isSeasonalProduct
 * @param {string[]} seasonDays
 * @param {string} [today]
 */
export function canAddProductDuringSeason(isSeasonalProduct, seasonDays, today = getTodayDateString()) {
    if (isSeasonalProduct || !isSacrificeDayToday(seasonDays, today)) {
        return { ok: true };
    }
    return {
        ok: false,
        message:
            "في أيام عيد الأضحى لا يمكن طلب منتجات عادية من الموقع. يرجى اختيار منتجات أضاحي العيد فقط.",
    };
}

/** @param {boolean | undefined | null} isSeasonal */
export function isSeasonalCart(isSeasonal) {
    return !!isSeasonal;
}
